import { academyLogger } from "utils/logger";
import { markAccessTokenIssued } from "../auth/sessionCoordinator";
const LOGIN_TRANSITION_KEY = "loginTransitionState";
const CONSOLE_HANDOFF_KEY = "consoleLoginHandoff";
const TRANSITION_TTL_MS = 5 * 60 * 1000;

const readJsonFromSession = (key) => {
  try {
    const rawValue = sessionStorage.getItem(key);
    return rawValue ? JSON.parse(rawValue) : null;
  } catch (error) {
    academyLogger.error(`Failed to parse sessionStorage key: ${key}`, error);
    sessionStorage.removeItem(key);
    return null;
  }
};

const isFresh = (data) => {
  if (!data?.startedAt) {
    return false;
  }

  return Date.now() - data.startedAt < TRANSITION_TTL_MS;
};

const notifyAuthStateChanged = () => {
  if (typeof window !== "undefined") {
    window.dispatchEvent(new Event("avps-auth-updated"));
  }
};

export const setLoginTransition = (target) => {
  sessionStorage.setItem(
    LOGIN_TRANSITION_KEY,
    JSON.stringify({
      target,
      startedAt: Date.now(),
    })
  );
};

export const getLoginTransition = () => {
  const transition = readJsonFromSession(LOGIN_TRANSITION_KEY);

  if (!transition) {
    return null;
  }

  if (!isFresh(transition)) {
    sessionStorage.removeItem(LOGIN_TRANSITION_KEY);
    return null;
  }

  return transition;
};

export const isLoginTransitionActive = (targets = []) => {
  const transition = getLoginTransition();

  if (!transition) {
    return false;
  }

  if (!Array.isArray(targets) || targets.length === 0) {
    return true;
  }

  return targets.includes(transition.target);
};

export const clearLoginTransition = () => {
  sessionStorage.removeItem(LOGIN_TRANSITION_KEY);
};

export const storeConsoleHandoffData = (handoffData = {}) => {
  sessionStorage.setItem(
    CONSOLE_HANDOFF_KEY,
    JSON.stringify({
      ...handoffData,
      startedAt: Date.now(),
    })
  );
};

export const getConsoleHandoffData = () => {
  const handoffData = readJsonFromSession(CONSOLE_HANDOFF_KEY);

  if (!handoffData) {
    return null;
  }

  if (!isFresh(handoffData)) {
    sessionStorage.removeItem(CONSOLE_HANDOFF_KEY);
    return null;
  }

  return handoffData;
};

export const clearConsoleHandoffData = () => {
  sessionStorage.removeItem(CONSOLE_HANDOFF_KEY);
};

export const stageAuthenticatedSession = ({
  token,
  email,
  roles = [],
  userData,
}) => {
  if (token) {
    localStorage.setItem("token", token);
  }

  if (email) {
    localStorage.setItem("email", email);
  }

  localStorage.setItem("userRoles", JSON.stringify(roles));

  if (userData) {
    localStorage.setItem("userData", JSON.stringify(userData));
  }

  localStorage.removeItem("isLoggedIn");
  localStorage.removeItem("isAuthenticated");
  notifyAuthStateChanged();
};

export const finalizeAuthenticatedSession = ({
  token,
  email,
  roles = [],
  userData,
}) => {
  stageAuthenticatedSession({ token, email, roles, userData });
  markAccessTokenIssued();
  localStorage.setItem("isLoggedIn", "true");
  localStorage.setItem("isAuthenticated", "true");
  clearLoginTransition();
  notifyAuthStateChanged();
};
